// components/connector/navigation.tsx
import React from "react";
import { ChevronLeft } from "lucide-react";

interface NavigationProps {
  currentStep: number;
  onBack: () => void;
  onContinue: () => void;
  onSubmit: () => void;
  canProceed: any;
  isLastStep: boolean;
}

export const Navigation: React.FC<NavigationProps> = ({
  currentStep,
  onBack,
  onContinue,
  onSubmit,
  canProceed,
  isLastStep,
}) => {
  return (
    <div className="flex justify-between items-center mt-12 pt-6 border-t border-gray-200">
      <button
        onClick={onBack}
        className="flex items-center space-x-2 px-4 py-2 text-gray-600 hover:text-gray-800"
      >
        <ChevronLeft className="h-4 w-4" />
        <span>{currentStep === 1 ? "Back to Connections" : "Back"}</span>
      </button>

      {!isLastStep ? (
        <button
          onClick={onContinue}
          disabled={!canProceed}
          className="px-6 py-2 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed"
        >
          Continue
        </button>
      ) : (
        <button
          onClick={onSubmit}
          className="px-6 py-2 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700"
        >
          Create Connection
        </button>
      )}
    </div>
  );
};